import React from "react";
import { Typography, Progress, Button } from "../../../core";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { MixStyle } from "../../../styles";

const btnProps = {
  width: "150px",
  height: "30px",
  border: "2px solid #FF5687",
  radius: "5px",
  fontSize: "16px",
  weight: "600",
};
const StyledProgress = styled(Progress)`
  ${MixStyle.flexCenter};
  margin: 50px auto;

  .ant-progress-circle-trail {
    stroke: #c9d6df;
  }
  .ant-progress-text {
    font-weight: 600;
    font-size: 36px;
    line-height: 54px;
    color: #404e67;
  }
`;
const StyledButton = styled(Button)`
  ${MixStyle.flexCenter};
`;

const StockDetailWraper = styled.div`
  margin: 20px 0px;
  .grey {
    background-color: #c9d6df;
  }
  .blue {
    background-color: #0084f8;
  }
  h5 {
    margin-bottom: 20px;
  }
  h5 > div {
    display: inline-flex;
    border-radius: 8.5px;
    width: 17px;
    height: 12px;
    margin-right: 10px;
  }
`;
const StockDetailContainer = styled.div`
  padding: 50px 0px;
  ${MixStyle.flexArround};
`;
const StockDetails = () => {
  let history = useHistory();
  function viewStock(params) {
    history.push("/yarn-stock");
  }
  function yarnReceiving(params) {
    // history.push("/yarn-stock");
  }
  return (
    <>
      <Typography as="h3" weight="500" color="#404E67" align="right">
        Filter
      </Typography>
      <StyledProgress className="d-flex h-center" type="circle" percent={75} />
      <StockDetailContainer className="f-wrap">
        <StockDetailWraper>
          <Typography
            as="h5"
            align="center"
            weight="500"
            noMargin
            color="#404E67"
          >
            <div className="grey"></div>
            Yarn in Stock
          </Typography>
          <Typography as="h3" align="center" weight="500" color="#404E67">
            990,95
          </Typography>
          <StyledButton
            {...btnProps}
            bg="transperant"
            color="#FF5687"
            onClick={viewStock}
          >
            View Stock
          </StyledButton>
        </StockDetailWraper>
        <StockDetailWraper>
          <Typography
            as="h5"
            align="center"
            weight="500"
            noMargin
            color="#404E67"
          >
            <div className="blue"></div> Yarn in Stock
          </Typography>
          <Typography as="h3" align="center" weight="500" color="#404E67">
            990,95
          </Typography>
          <StyledButton
            {...btnProps}
            bg="transperant"
            color="#FF5687"
            onClick={yarnReceiving}
          >
            Yarn Receiving
          </StyledButton>
        </StockDetailWraper>
      </StockDetailContainer>
    </>
  );
};

export default StockDetails;
